export default class proyecto{
	constructor($scope,
				$routeParams,
				method,
				proyectosService,
                clientesService,
				$location,
                $uibModal,
                toastr,
                tipoEquipoService,
                $q
				){
		this.scope    = $scope;
		this.location = $location;
        this.toastr = toastr;
        this.q = $q;
        this.modal = $uibModal;
		switch (method) {
			case 'list':
				this.list(proyectosService);
			break;
			case 'new':
				this.create(proyectosService, clientesService, tipoEquipoService);
			break;
			case 'view':
				this.view($routeParams, proyectosService, clientesService,tipoEquipoService);
			break;
		}
	}

	list(proyectosService){

        let self = this.scope;
        proyectosService.getAllList().then((resp, err) => {
			self.proyectos = resp.data.message;
		});

        self.getItemPage = (item) => {
            let index = self.proyectos.indexOf(item);
            let pageNumber = Math.floor(index / 5) + 1;
            return pageNumber;
        };

        self.eliminar = this.eliminar.bind(this, proyectosService);
	}

	create(proyectosService, clientesService, tipoEquipoService){


        this.scope.proyecto = {};
        this.scope.lista = {
            izquierda: [],
            derecha: [],
            addVal: [],
            removeVal: [],
        };


        this.diference = (iz, der) => {
            for (var el in der) {
                let aux = der[el];
                let index = _.findIndex(iz, (e) => {
                    return e._id == aux._id
                });
                if (index >= 0) {
                    iz.splice(index, 1);
                }
            }
            return iz;
        };

        this.scope.lista.options = {
            leftContainerLabel: 'Tipo de equipos disponibles',
            rightContainerLabel: 'Tipo de equipos Seleccionados',
            active: true
        };

        tipoEquipoService.getAll()
                .then((resp) => {
                    this.scope.lista.izquierda = resp.data.message;
                })

        clientesService.getAllList()
            .then((resp) => {
                this.scope.clientes  = resp.data.message;
            });

        this.scope.inAction = false;
		this.scope.guardar = () => {
            if (!this.scope.inAction) {
                this.scope.inAction = true;
                console.log(self.proyecto);
                this.scope.proyecto.listado_tipo_equipo = this.scope.lista.derecha;
                proyectosService.save(this.scope.proyecto).then((resp) => {
                    this.toastr.success('Proyecto creado correctamente!', 'Success!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                    this.location.path('/proyecto');
                })
                .catch((err) => {
                    this.scope.inAction = false;
                    this.toastr.error('Error', 'Error al crear el Proyecto!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                });
            }
		};
	}

	view($routeParams,
         proyectosService,
         clientesService,
         tipoEquipoService){

        this.scope.lista = {
            izquierda: [],
            derecha: [],
            addVal: [],
            removeVal: [],
        };


        this.diference = (iz, der) => {
            for (var el in der) {
                let aux = der[el];
                let index = _.findIndex(iz, (e) => {
                    return e._id == aux._id
                });
                if (index >= 0) {
                    iz.splice(index, 1);
                }
            }
            return iz;
        };

        this.scope.lista.options = {
            leftContainerLabel: 'Tipo de equipos disponibles',
            rightContainerLabel: 'Tipo de equipos Seleccionados',
            active: true
        };

        clientesService.getAllList()
            .then((resp) => {
                this.scope.clientes  = resp.data.message;
            });
        
        this.q.all([
            proyectosService.getById({_id: $routeParams.id}).then((resp) => {
                this.scope.proyecto = resp.data.message;
                this.scope.lista.derecha = resp.data.message.listado_tipo_equipo;
            }).catch((er) => {
                console.log(er);
            }),
            tipoEquipoService.getAll()
                .then((resp) => {
                    this.scope.lista.izquierda = resp.data.message;
                })
        ]).then(() => {
            let iz = this.scope.lista.izquierda;
            let der = this.scope.lista.derecha;
            this.scope.lista.izquierda = this.diference(iz, der);
        });

        this.scope.inAction = false;
		this.scope.guardar = () => {
            if (!this.scope.inAction) {
                this.scope.inAction = true;
                
                this.scope.proyecto.listado_tipo_equipo = this.scope.lista.derecha;
                proyectosService.update(this.scope.proyecto).then((resp) => {
                    this.toastr.success('Proyecto modificado correctamente!', 'Success!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                    this.location.path('/proyecto');
                })
                .catch((err) => {
                    this.scope.inAction = false;
                    this.toastr.error('Error', 'Error al modificar el Proyecto!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                });
            }
		};
	}

    eliminar(service,object, page, index) {
        let self = this;
        let templateModal = `
			    <div class="modal-content">
			      <div class="modal-header">
			        <h4 class="modal-title" id="myModalLabel">Eliminar Proyecto</h4>
			      </div>
			      <div class="modal-body">
                		¿Quiere eliminar el proyecto: {{ctr.nombre}}?
			      </div>
			      <div class="modal-footer">
			        <button type="button" class="btn btn-default" ng-click="ctr.no()">NO</button>
			        <button type="button" class="btn btn-primary" ng-click="ctr.si()">SI</button>
			      </div>
			    </div>
		`;
        let modal = this.modal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            template: templateModal,
            controller: function () {
                let vm = this;
                vm.nombre = object.nombre;
                this.no = () => {
                    let data = {
                        delete: false
                    };
                    modal.close(data);
                };

                this.si = () => {
                    let data = {
                        delete: true,
                        index: (page - 1) * 5 + index
                    };
                    modal.close(data);
                };
            },
            controllerAs: 'ctr',
            size: 'md'
        });

        modal.result.then((resp) => {
            if (resp.delete) {
                let indexObject = resp.index;
                self.inAction = true;
                service.delete({_id: object._id}).then((resp) => {
                    self.scope.proyectos.splice(indexObject, 1);
                    self.inAction = false;
                    this.toastr.success('Proyecto eliminado correctamente!', 'Success!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                })
                    .catch((err) => {
                        self.inAction = false;
                        this.toastr.error('Error al eliminar el proyecto!','Error',  {
                            timeOut: 2000,
                            closeButton: true
                        });
                    });
            }

        }, (exit) => {
            console.log('modal close');
        });
    }
}


// WEBPACK FOOTER //
// ./app/js/controllers/proyecto/proyecto.js